<template>
  <div>
    <div class="row">
      <div class="col-xs-12">
        <div class="form-group">
          <label for>Type</label>
          <select v-model="panel.graphType">
            <option :value="undefined">-- Select --</option>
            <option v-for="(option,index) in definition.availableGraphTypes" :key="index" :value="option">{{option}}</option>
          </select>
        </div>
      </div>
      <div class="col-xs-12">
        <div class="form-group">
          <label for>Background Colour</label>
          <select v-model="panel.backgroundColour">
            <option value>-- Select Colour--</option>
            <option v-for="(option, index) in colours.arr" :key="index" :value="option.value">{{option.label}}</option>
          </select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import colours from "../../../utils/colours";
export default {
  props: ["definition", "panel"],
  data() {
    return {
      colours
    };
  }
};
</script>

<style>
</style>
